export interface MapDef { key: string; label: string; short: string; }
export interface MapGroup { label: string; scope: 'person' | 'co'; defs: MapDef[]; }

/** 뒷단계의 모든 소비처(정보 입력·자료 업로드 연동·문서 자동생성 치환) 카탈로그 */
export const MAPGROUPS: MapGroup[] = [
  {
    label: '2단계 · GP 교육', scope: 'person', defs: [
      { key: 'eduIdPw', label: 'GP 교육 - 교육사이트 ID/PW (2단계 표시)', short: '교육 ID/PW' },
    ],
  },
  {
    label: '마스터', scope: 'person', defs: [
      { key: 'orgAddr', label: '마스터 - 소재지', short: '마스터 소재지' },
      { key: 'gpRrn', label: '마스터 - GP 주민번호 (신분증 보기)', short: '마스터 GP 주민번호' },
      { key: 'gpAddr', label: '마스터 - GP 집주소 (등본 보기)', short: '마스터 GP 집주소' },
      { key: 'lpRrn', label: '마스터 - LP 주민번호 (등본 보기)', short: '마스터 LP 주민번호' },
      { key: 'lpAddr', label: '마스터 - LP 집주소 (등본 보기)', short: '마스터 LP 집주소' },
    ],
  },
  {
    label: '고유번호증 발급신청', scope: 'person', defs: [
      { key: 'idCard', label: '고유번호증 발급신청 - GP 신분증', short: 'GP 신분증' },
    ],
  },
  {
    label: '6단계 · GP 정보 요청', scope: 'person', defs: [
      { key: 'creditIdPw', label: 'GP 정보 요청 - 신용정보 조회사이트 ID/PW (6단계 표시)', short: '신용조회 ID/PW' },
    ],
  },
  {
    label: '전환사채 발행', scope: 'co', defs: [
      { key: 'co_biz', label: '전환사채 발행 - 사업자등록증', short: '사업자등록증' },
      { key: 'co_rule', label: '전환사채 발행 - 정관', short: '정관' },
      { key: 'co_reg', label: '전환사채 발행 - 법인 등기부등본', short: '등기부등본' },
      { key: 'co_fin', label: '전환사채 발행 - 최근연도 재무제표', short: '재무제표' },
      { key: 'co_roster', label: '전환사채 발행 - 주주명부', short: '주주명부' },
    ],
  },
  {
    label: '벤처기업 확인신청', scope: 'co', defs: [
      { key: 'co_biz', label: '벤처기업 확인신청 - 사업자등록증', short: '사업자등록증' },
      { key: 'co_idpw', label: '벤처기업 확인신청 - 확인시스템 ID·PW', short: '확인시스템 ID/PW' },
      { key: 'co_fin', label: '벤처기업 확인신청 - 3개년 재무제표', short: '재무제표' },
      { key: 'co_vat', label: '벤처기업 확인신청 - 최근 부가세 신고서', short: '부가세' },
      { key: 'co_sme', label: '벤처기업 확인신청 - 중소기업 확인서', short: '중소기업확인서' },
    ],
  },
];

/** 매핑이 안 된 레거시 항목용 제목 키워드 폴백 */
export const KW_FALLBACK: Record<string, string> = {
  eduIdPw: '엔젤투자교육', eduCert: '수료증',
  orgAddr: '조합 소재지', gpRrn: '주민등록번호', gpAddr: '거주지 주소', gpEdu: '학력', gpCareer: '경력',
  lpRrn: '주민등록번호', lpAddr: '거주지 주소', lpPhone: '휴대폰',
  idCard: '신분증 사본', rrnCopy: '주민등록등본', creditIdPw: '신용정보 조회',
  co_biz: '사업자등록증', co_rule: '정관', co_reg: '등기부등본', co_fin: '재무제표', co_roster: '주주명부',
  co_idpw: '확인시스템', co_sme: '중소기업확인서', co_vat: '부가세',
};

/** 드롭다운엔 노출하지 않지만 기존 매핑·칩 라벨용으로 보존하는 내부 키 */
const LEGACY_DEFS: MapDef[] = [
  { key: 'eduCert', label: '교육 수료증', short: '교육 수료증' },
  { key: 'gpEdu', label: 'GP 최종학력', short: '마스터 학력' },
  { key: 'gpCareer', label: 'GP 주요경력', short: '마스터 경력' },
  { key: 'rrnCopy', label: '주민등록등본', short: '등본' },
];

const ALL: MapDef[] = MAPGROUPS.reduce<MapDef[]>((a, g) => a.concat(g.defs), []).concat(LEGACY_DEFS);

export function mapShort(key: string): string {
  const d = ALL.find((x) => x.key === key);
  return d ? d.short : key;
}
export function groupsFor(scope: 'person' | 'co'): MapGroup[] {
  return MAPGROUPS.filter((g) => g.scope === scope);
}
